import HttpRequest from "./HttpRequest";
import Objects from "../utils/Objects";
import RedirectService from "./RedirectService";
import Notify from "./Notify";
import UserService from "./UserService";

export default class AuthenticationService {

  httpRequest = new HttpRequest();

  logout() {
    this.httpRequest.get('auth/v1/logout').then(
      () => {
        UserService.currentUser = null;
        this.httpRequest.setToken(null);
        Notify.success('Vocẽ saiu!');
        window.location = '/accounts'
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js